/**
 * Easing: easeInOutQuint
 * Duration: 1500ms (default)
 */
function easeInOutQuint(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 - Math.pow(-2 * t + 2, 5) / 2;
}

/**
 * Smoothly scroll the window to a given top position.
 * @param {number} targetTop - The target scrollY position in pixels.
 * @param {number} [duration=1500] - Duration in milliseconds.
 */
export function smoothScrollTo(targetTop, duration = 1500) {
  if (window.__lenis) {
    window.__lenis.scrollTo(targetTop, { duration: duration / 1000, easing: easeInOutQuint });
    return;
  }

  const startTop = window.scrollY;
  const distance = targetTop - startTop;
  let startTime = null;

  function step(timestamp) {
    if (!startTime) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = easeInOutQuint(progress);
    window.scrollTo(0, startTop + distance * ease);
    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

/**
 * Smoothly scroll an element into view (top-aligned with optional offset).
 * @param {HTMLElement} element - The target element.
 * @param {number} [offset=0] - Additional pixel offset from the top.
 * @param {number} [duration=1500] - Duration in milliseconds.
 */
export function smoothScrollIntoView(element, offset = 0, duration = 1500) {
  if (!element) return;

  if (window.__lenis) {
    window.__lenis.scrollTo(element, { offset: -offset, duration: duration / 1000, easing: easeInOutQuint });
    return;
  }

  const rect = element.getBoundingClientRect();
  const targetTop = window.scrollY + rect.top - offset;
  smoothScrollTo(targetTop, duration);
}
